import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/ALEXANDRA-EECKHOOT.jpg");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/le-salon-intro.jpg");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/our-work1.png");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/our-work2.png");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/our-work3.png");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/our-work4.png");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/our-work5.png");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/our-work6.png");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/our-work7.png");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/salon-au-grey-des-couleurs.webp");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/salon-head-spa.jpg");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/salon-villejuif.webp");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/assets/images/salons/ville-d-avray.webp");
;
import(/* webpackMode: "eager", webpackExports: ["BreadcrumbHomepage"] */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/components/sections/breadcrumb-homepage/BreadcrumbHomepage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FindUsSection"] */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/app/components/sections/find-us/FindUsSection.tsx");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/node_modules/@iconify/react/dist/iconify.js");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/build/ef1681e2-954f-41cf-bc5c-afa879d44921/frontend/node_modules/next/dist/client/link.js");
